'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { PrismicNextImage } from '@prismicio/next';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import React, { useMemo } from 'react';
import { useIsDesktop } from '@/hooks/useMediaQuery';
import { defaultSettings } from './consts';
import { Props } from './types';
const ImageCarousel = t0 => {
  const $ = _c(17);
  const {
    slides,
    settings: t1
  } = t0;
  const settings = t1 === undefined ? defaultSettings : t1;
  const isDesktop = useIsDesktop();
  settings?.desktopFeatures?.autoplay;
  settings?.mobileFeatures?.autoplay;
  let t2;
  bb0: {
    if (isDesktop && !!settings?.desktopFeatures?.autoplay) {
      const t3 = settings?.desktopFeatures?.autoplay;
      let t4;
      if ($[0] !== t3) {
        t4 = Autoplay({
          delay: t3,
          stopOnInteraction: false
        });
        $[0] = t3;
        $[1] = t4;
      } else {
        t4 = $[1];
      }
      let t5;
      if ($[2] !== t4) {
        t5 = [t4];
        $[2] = t4;
        $[3] = t5;
      } else {
        t5 = $[3];
      }
      t2 = t5;
      break bb0;
    }
    if (!isDesktop && !!settings?.mobileFeatures?.autoplay) {
      const t3 = settings?.mobileFeatures?.autoplay;
      let t4;
      if ($[4] !== t3) {
        t4 = Autoplay({
          delay: t3,
          stopOnInteraction: false
        });
        $[4] = t3;
        $[5] = t4;
      } else {
        t4 = $[5];
      }
      let t5;
      if ($[6] !== t4) {
        t5 = [t4];
        $[6] = t4;
        $[7] = t5;
      } else {
        t5 = $[7];
      }
      t2 = t5;
      break bb0;
    }
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = [];
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = t3;
  }
  const additionalFeatures = t2;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      loop: true,
      align: "center"
    };
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const [emblaRef] = useEmblaCarousel(t3, additionalFeatures);
  let t4;
  if ($[10] !== slides) {
    t4 = slides.map(_temp);
    $[10] = slides;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <div className="auto-cols-full md:auto-cols-half grid w-full grid-flow-col lg:auto-cols-[40%]">{t4}</div>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== emblaRef || $[15] !== t5) {
    t6 = <div className="relative" data-sentry-component="ImageCarousel" data-sentry-source-file="index.tsx"><div className="overflow-hidden pr-4 pl-2 lg:pr-0 lg:pl-0" ref={emblaRef}>{t5}</div></div>;
    $[14] = emblaRef;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default ImageCarousel;
function _temp(item, index) {
  return <div className="flex px-2 lg:px-2.5" key={index}><PrismicNextImage fallbackAlt="" className="min-h-full w-full overflow-hidden rounded-lg object-cover object-center lg:rounded-xl" field={item.slide} /></div>;
}